import $aQscD$intlarAEmjs from "./intl/ar-AE.mjs";
import $aQscD$intlbgBGmjs from "./intl/bg-BG.mjs";
import $aQscD$intlcsCZmjs from "./intl/cs-CZ.mjs";
import $aQscD$intldaDKmjs from "./intl/da-DK.mjs";
import $aQscD$intldeDEmjs from "./intl/de-DE.mjs";
import $aQscD$intlelGRmjs from "./intl/el-GR.mjs";
import $aQscD$intlenUSmjs from "./intl/en-US.mjs";
import $aQscD$intlesESmjs from "./intl/es-ES.mjs";
import $aQscD$intletEEmjs from "./intl/et-EE.mjs";
import $aQscD$intlfiFImjs from "./intl/fi-FI.mjs";
import $aQscD$intlfrFRmjs from "./intl/fr-FR.mjs";
import $aQscD$intlheILmjs from "./intl/he-IL.mjs";
import $aQscD$intlhrHRmjs from "./intl/hr-HR.mjs";
import $aQscD$intlhuHUmjs from "./intl/hu-HU.mjs";
import $aQscD$intlitITmjs from "./intl/it-IT.mjs";
import $aQscD$intljaJPmjs from "./intl/ja-JP.mjs";
import $aQscD$intlkoKRmjs from "./intl/ko-KR.mjs";
import $aQscD$intlltLTmjs from "./intl/lt-LT.mjs";
import $aQscD$intllvLVmjs from "./intl/lv-LV.mjs";
import $aQscD$intlnbNOmjs from "./intl/nb-NO.mjs";
import $aQscD$intlnlNLmjs from "./intl/nl-NL.mjs";
import $aQscD$intlplPLmjs from "./intl/pl-PL.mjs";
import $aQscD$intlptBRmjs from "./intl/pt-BR.mjs";
import $aQscD$intlptPTmjs from "./intl/pt-PT.mjs";
import $aQscD$intlroROmjs from "./intl/ro-RO.mjs";
import $aQscD$intlruRUmjs from "./intl/ru-RU.mjs";
import $aQscD$intlskSKmjs from "./intl/sk-SK.mjs";
import $aQscD$intlslSImjs from "./intl/sl-SI.mjs";
import $aQscD$intlsrSPmjs from "./intl/sr-SP.mjs";
import $aQscD$intlsvSEmjs from "./intl/sv-SE.mjs";
import $aQscD$intltrTRmjs from "./intl/tr-TR.mjs";
import $aQscD$intlukUAmjs from "./intl/uk-UA.mjs";
import $aQscD$intlzhCNmjs from "./intl/zh-CN.mjs";
import $aQscD$intlzhTWmjs from "./intl/zh-TW.mjs";

var $aa5f63badbfee5df$exports = {};


































$aa5f63badbfee5df$exports = {
    "ar-AE": $aQscD$intlarAEmjs,
    "bg-BG": $aQscD$intlbgBGmjs,
    "cs-CZ": $aQscD$intlcsCZmjs,
    "da-DK": $aQscD$intldaDKmjs,
    "de-DE": $aQscD$intldeDEmjs,
    "el-GR": $aQscD$intlelGRmjs,
    "en-US": $aQscD$intlenUSmjs,
    "es-ES": $aQscD$intlesESmjs,
    "et-EE": $aQscD$intletEEmjs,
    "fi-FI": $aQscD$intlfiFImjs,
    "fr-FR": $aQscD$intlfrFRmjs,
    "he-IL": $aQscD$intlheILmjs,
    "hr-HR": $aQscD$intlhrHRmjs,
    "hu-HU": $aQscD$intlhuHUmjs,
    "it-IT": $aQscD$intlitITmjs,
    "ja-JP": $aQscD$intljaJPmjs,
    "ko-KR": $aQscD$intlkoKRmjs,
    "lt-LT": $aQscD$intlltLTmjs,
    "lv-LV": $aQscD$intllvLVmjs,
    "nb-NO": $aQscD$intlnbNOmjs,
    "nl-NL": $aQscD$intlnlNLmjs,
    "pl-PL": $aQscD$intlplPLmjs,
    "pt-BR": $aQscD$intlptBRmjs,
    "pt-PT": $aQscD$intlptPTmjs,
    "ro-RO": $aQscD$intlroROmjs,
    "ru-RU": $aQscD$intlruRUmjs,
    "sk-SK": $aQscD$intlskSKmjs,
    "sl-SI": $aQscD$intlslSImjs,
    "sr-SP": $aQscD$intlsrSPmjs,
    "sv-SE": $aQscD$intlsvSEmjs,
    "tr-TR": $aQscD$intltrTRmjs,
    "uk-UA": $aQscD$intlukUAmjs,
    "zh-CN": $aQscD$intlzhCNmjs,
    "zh-TW": $aQscD$intlzhTWmjs
};


export {$aa5f63badbfee5df$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
